/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import { cn } from "tailwind-variants";
import { acceptedFileTypes } from "common/file-type-helper";
import { readCookie } from "common/utils/cookie";
import initDeliveryDateSimple from "components/jiffy/product-details-delivery-date-simple/product-details-delivery-date-simple";
import initProductSavedCartsSelector from "components/jiffy/product-saved-carts-selector/product-saved-carts-selector";
import BogoInfo from "./BogoInfo.vue";
import { useUserBackButtonClickDetector } from "./common/composables/useUserBackButtonClickDetector";
import { useUserInactivityDetector } from "./common/composables/useUserInactivityDetector";
import JerseyNumbers from "./JerseyNumbers/JerseyNumbers.vue";
import Letters from "./Letters/Letters.vue";
import ProColorUpsell from "./ProColorUpsell.vue";
import PuffColorSelector from "./PuffColorSelector.vue";
import StickersTools from "./Stickers/StickersTools/StickersTools.vue";
import { isArtworkWithError, toggleGlobalDtfError } from "./utils";
import { api } from "jiffy-api";
import { EventBus, Events } from "jiffy-store";
// Relative paths
import UseSvg from "common/vue/components/UseSvg.react.vue";
import DtfTransferUserRetentionModal from "./common/DtfTransferUserRetentionModal.vue";
import {
  isDtfUserRetentionModalShown,
  setDtfUserRetentionModalShown
} from "./common/dtfUserRetentionHelper";
import ArtworkCTA from "./ArtworkCTA.vue";
import ArtworkDimensions from "./ArtworkDimensions.vue";
import ArtworkError from "./ArtworkError.vue";
import ArtworkHistoryModal from "./ArtworkHistoryModal.vue";
import ArtworkImage from "./ArtworkImage.vue";
import ArtworkInfo from "./ArtworkInfo.vue";
import MultiSizeStep from "./ArtworkMultiSize/MultiSizeStep.vue";
import MultiSizeTotal from "./ArtworkMultiSize/MultiSizeTotal.vue";
import ArtworkNotification from "./ArtworkNotification.vue";
import ArtworkQualityConfigPanel from "./ArtworkQualityConfigPanel.vue";
import ArtworkQualityConfigPanelAbAiMonetization from "./ArtworkQualityConfigPanel/ArtworkQualityConfigPanel.vue";
import ArtworkQuantity from "./ArtworkQuantity.vue";
import {
  DTF001_CATALOG_NUMBER,
  INACTIVITY_INTERVAL,
  INACTIVITY_MAX_CALL_COUNT,
  MODAL_TRIGGER_POINTS,
  PDP_TYPE_GANG_SHEETS
} from "./common/constants";
import FreeTransfersBadge from "./common/FreeTransfersBadge.vue";
import StepWrapper from "./common/StepWrapper.vue";
import TransfersStoreCredit from "./common/TransfersStoreCredit.vue";
import DeliveryDate from "./DeliveryDate.vue";
import DesignTagCreationPanel from "./DesignTagCreationPanel.vue";
import DropZone from "./DropZone.vue";
import DtfAddToCart from "./DtfAddToCart.vue";
import DtfConfirmationModal from "./DtfConfirmationModal.vue";
import DtfSpanglesActions from "./DtfSpanglesActions.vue";
import DtfSpanglesColorSelector from "./DtfSpanglesColorSelector.vue";
import DtfSpangleVersions from "./DtfSpangleVersions.vue";
import GangSheetBuilderPdpContainer from "./GangSheetBuilderPdp/GangSheetBuilderPdpContainer.vue";
import GangSheetInfoModal from "./GangSheetInfoModal.vue";
import MultiArtworkModal from "./MultiArtworkModal.vue";
import NotifyOnRestock from "./NotifyOnRestock.vue";
import PinningSessionModal from "./PinningSession/PinningSessionModal.vue";
import PreCut from "./PreCut.vue";
import RedrawNotes from "./RedrawNotes.vue";
import { SPANGLE_MODES, useSpanglesStore } from "./spangles-module";
import StickerSampleBanner from "./StickerSampleBanner.vue";
import { useDtfStore } from "./store";
import TrimInfo from "./TrimInfo.vue";
import UploadBox from "./UploadBox.vue";
import "./ProductDetailsDtf.scss";

const hasVisibleArtworks = (artworks: any) =>
  artworks.length > 0 &&
  artworks.some(
    (artwork: any) =>
      artwork &&
      !artwork.isSimulated &&
      !artwork.isFile &&
      !artwork.uploadError &&
      !artwork.isLoading &&
      artwork.id &&
      typeof parseInt(artwork.id, 10) === "number" &&
      !Number.isNaN(parseInt(artwork.id, 10)) &&
      artwork.enhancementCompleted === true
  );

const hasArtworksWithPinningSession = (artworks: any) =>
  artworks.length > 0 && artworks.some((artwork: any) => Boolean(artwork?.pinningSessionId));

function ProductDetailsDtf({
  locale = "en-US",
  currentStore = null,
  ref,
  children,
  slots = {},
  className: restClassName,
  ...restProps
}: any) {
  // @ts-expect-error TS(6133): 't' is declared but its value is never read.
  const { formatMessage: t } = useIntl();
  const pdpStore = useDtfStore();
  const spanglesStore = useSpanglesStore();
  // Setup state
  const [triggerPoint, setTriggerPoint] = useState(MODAL_TRIGGER_POINTS.NONE);
  const [showDtfRetentionModal, setShowDtfRetentionModal] = useState(false);

  // Data state
  const [sizeMessageMaxSize] = useState(10);
  // @ts-expect-error TS(6133): 'showComparisonModal' is declared but its value is... Remove this comment to see the full error message
  const [showComparisonModal, setShowComparisonModal] = useState(false);
  const [activeConfigSection, setActiveConfigSection] = useState("jiffy-print-perfect");
  // @ts-expect-error TS(6133): 'hasNoPrintTransfersHistory' is declared but its v... Remove this comment to see the full error message
  const [hasNoPrintTransfersHistory, setHasNoPrintTransfersHistory] = useState(null);
  const [cartHasBlanks, setCartHasBlanks] = useState(false);

  // Refs
  const fileRef = useRef(null);
  const handleItemsAddedToCartRef = useRef(null);
  const handleCartQuantityUpdatedRef = useRef(null);
  const prevArtworksRef = useRef(null);

  // Set locale on mount and when it changes
  useEffect(() => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.setLocale(locale);
  }, [locale, pdpStore]);

  // Computed properties as functions
  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return pdpStore.artworks;
  }

  function files() {
    // @ts-expect-error TS(4111): Property 'files' comes from an index signature, so... Remove this comment to see the full error message
    return pdpStore.files;
  }

  function fileToRemove() {
    // @ts-expect-error TS(4111): Property 'fileToRemove' comes from an index signat... Remove this comment to see the full error message
    return pdpStore.fileToRemove;
  }

  function showDiscardModal() {
    // @ts-expect-error TS(4111): Property 'showDiscardModal' comes from an index si... Remove this comment to see the full error message
    return pdpStore.showDiscardModal;
  }

  function showFilesError() {
    // @ts-expect-error TS(4111): Property 'showFilesError' comes from an index sign... Remove this comment to see the full error message
    return pdpStore.showFilesError;
  }

  function replaceArtwork() {
    // @ts-expect-error TS(4111): Property 'replaceArtwork' comes from an index sign... Remove this comment to see the full error message
    return pdpStore.replaceArtwork;
  }

  function modalArtworks() {
    // @ts-expect-error TS(4111): Property 'modalArtworks' comes from an index signa... Remove this comment to see the full error message
    return pdpStore.modalArtworks;
  }

  function outOfStock() {
    // @ts-expect-error TS(4111): Property 'outOfStock' comes from an index signatur... Remove this comment to see the full error message
    return pdpStore.outOfStock;
  }

  function pdpType() {
    // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
    return pdpStore.pdpType;
  }

  function printAsIs() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return pdpStore.printAsIs;
  }

  function showCTA() {
    // @ts-expect-error TS(4111): Property 'showCTA' comes from an index signature, ... Remove this comment to see the full error message
    return pdpStore.showCTA;
  }

  function showModal() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return pdpStore.showModal;
  }

  function sticker() {
    // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
    return pdpStore.sticker;
  }

  function withPreCut() {
    // @ts-expect-error TS(4111): Property 'withPreCut' comes from an index signatur... Remove this comment to see the full error message
    return pdpStore.withPreCut;
  }

  function showArtworkHistoryModal() {
    // @ts-expect-error TS(4111): Property 'showArtworkHistoryModal' comes from an i... Remove this comment to see the full error message
    return pdpStore.showArtworkHistoryModal;
  }

  function isMobile() {
    // @ts-expect-error TS(4111): Property 'isMobile' comes from an index signature,... Remove this comment to see the full error message
    return pdpStore.isMobile;
  }

  function catalogNumber() {
    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
    return pdpStore.catalogNumber;
  }

  function isSticker() {
    // @ts-expect-error TS(4111): Property 'isSticker' comes from an index signature... Remove this comment to see the full error message
    return pdpStore.isSticker;
  }

  function isDieCutSticker() {
    // @ts-expect-error TS(4111): Property 'isDieCutSticker' comes from an index sig... Remove this comment to see the full error message
    return pdpStore.isDieCutSticker;
  }

  function isStickerSample() {
    // @ts-expect-error TS(4111): Property 'isStickerSample' comes from an index sig... Remove this comment to see the full error message
    return pdpStore.isStickerSample;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return pdpStore.isSpangle;
  }

  function isPuff() {
    // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
    return pdpStore.isPuff;
  }

  function isLetters() {
    // @ts-expect-error TS(4111): Property 'isLetters' comes from an index signature... Remove this comment to see the full error message
    return pdpStore.isLetters;
  }

  function isFirstArtworkMinQuantityInvalid() {
    // @ts-expect-error TS(4111): Property 'isFirstArtworkMinQuantityInvalid' comes ... Remove this comment to see the full error message
    return pdpStore.isFirstArtworkMinQuantityInvalid;
  }

  function variantId() {
    // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
    return pdpStore.variantId;
  }

  function experiments() {
    // @ts-expect-error TS(4111): Property 'experiments' comes from an index signatu... Remove this comment to see the full error message
    return pdpStore.experiments;
  }

  function isJerseyNumbers() {
    // @ts-expect-error TS(4111): Property 'isJerseyNumbers' comes from an index sig... Remove this comment to see the full error message
    return pdpStore.isJerseyNumbers;
  }

  function isGuest() {
    // @ts-expect-error TS(4111): Property 'isGuest' comes from an index signature, ... Remove this comment to see the full error message
    return pdpStore.isGuest;
  }

  function showStepsUI() {
    // @ts-expect-error TS(4111): Property 'showStepsUI' comes from an index signatu... Remove this comment to see the full error message
    return pdpStore.showStepsUI;
  }

  function showRedrawUI() {
    // @ts-expect-error TS(4111): Property 'showRedrawUI' comes from an index signat... Remove this comment to see the full error message
    return pdpStore.showRedrawUI;
  }

  function showMultiSize() {
    // @ts-expect-error TS(4111): Property 'showMultiSize' comes from an index signa... Remove this comment to see the full error message
    return pdpStore.showMultiSize;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return pdpStore.isStandardArtwork;
  }

  function enableAbAiMonetization() {
    // @ts-expect-error TS(4111): Property 'enableAbAiMonetization' comes from an in... Remove this comment to see the full error message
    return pdpStore.enableAbAiMonetization;
  }

  function simulation() {
    // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
    return pdpStore.simulation;
  }

  function storeCreditInfo() {
    // @ts-expect-error TS(4111): Property 'storeCreditInfo' comes from an index sig... Remove this comment to see the full error message
    return pdpStore.storeCreditInfo;
  }

  function isGangSheetBuilder() {
    // @ts-expect-error TS(4111): Property 'isGangSheetBuilder' comes from an index ... Remove this comment to see the full error message
    return pdpStore.isGangSheetBuilder;
  }

  function reorderEnabled() {
    // @ts-expect-error TS(4111): Property 'reorderEnabled' comes from an index sign... Remove this comment to see the full error message
    return pdpStore.reorderEnabled;
  }

  function paidExpertEditAddonEnabled() {
    // @ts-expect-error TS(4111): Property 'paidExpertEditAddonEnabled' comes from a... Remove this comment to see the full error message
    return pdpStore.paidExpertEditAddonEnabled;
  }

  function neckLabel() {
    // @ts-expect-error TS(4111): Property 'neckLabel' comes from an index signature... Remove this comment to see the full error message
    return pdpStore.neckLabel;
  }

  function blankItemsCount() {
    // @ts-expect-error TS(4111): Property 'blankItemsCount' comes from an index sig... Remove this comment to see the full error message
    return pdpStore.blankItemsCount;
  }

  // @ts-expect-error TS(6133): 'transfersInCartCount' is declared but its value i... Remove this comment to see the full error message
  function transfersInCartCount() {
    // @ts-expect-error TS(4111): Property 'transfersInCartCount' comes from an inde... Remove this comment to see the full error message
    return pdpStore.transfersInCartCount;
  }

  function isBogoApplicable() {
    // @ts-expect-error TS(4111): Property 'isBogoApplicable' comes from an index si... Remove this comment to see the full error message
    return pdpStore.isBogoApplicable;
  }

  function isNewToTransfers() {
    // @ts-expect-error TS(4111): Property 'isNewToTransfers' comes from an index si... Remove this comment to see the full error message
    return pdpStore.isNewToTransfers;
  }

  function transferPdpInactivityDetection() {
    // @ts-expect-error TS(4111): Property 'transferPdpInactivityDetection' comes fr... Remove this comment to see the full error message
    return pdpStore.transferPdpInactivityDetection;
  }

  function transferPdpBackButtonDetection() {
    // @ts-expect-error TS(4111): Property 'transferPdpBackButtonDetection' comes fr... Remove this comment to see the full error message
    return pdpStore.transferPdpBackButtonDetection;
  }

  function isPinBasedRedrawEnabled() {
    // @ts-expect-error TS(4111): Property 'isPinBasedRedrawEnabled' comes from an i... Remove this comment to see the full error message
    return pdpStore.isPinBasedRedrawEnabled;
  }

  function bogoEligibility() {
    // @ts-expect-error TS(4111): Property 'bogoEligibility' comes from an index sig... Remove this comment to see the full error message
    return pdpStore.bogoEligibility;
  }

  function bogoMaxDimensionLabel() {
    // @ts-expect-error TS(4111): Property 'bogoMaxDimensionLabel' comes from an ind... Remove this comment to see the full error message
    return pdpStore.bogoMaxDimensionLabel;
  }

  function promotionResolution() {
    // @ts-expect-error TS(4111): Property 'promotionResolution' comes from an index... Remove this comment to see the full error message
    return pdpStore.promotionResolution;
  }

  function showPinningModal() {
    // @ts-expect-error TS(4111): Property 'showPinningModal' comes from an index si... Remove this comment to see the full error message
    return pdpStore.showPinningModal;
  }

  function pinningArtworkIndex() {
    // @ts-expect-error TS(4111): Property 'pinningArtworkIndex' comes from an index... Remove this comment to see the full error message
    return pdpStore.pinningArtworkIndex;
  }

  function pinningModalSessionId() {
    // @ts-expect-error TS(4111): Property 'pinningModalSessionId' comes from an ind... Remove this comment to see the full error message
    return pdpStore.pinningModalSessionId;
  }

  function pendingPinningInvalidation() {
    // @ts-expect-error TS(4111): Property 'pendingPinningInvalidation' comes from a... Remove this comment to see the full error message
    return pdpStore.pendingPinningInvalidation;
  }

  function lastConfirmedConfigSection() {
    // @ts-expect-error TS(4111): Property 'lastConfirmedConfigSection' comes from a... Remove this comment to see the full error message
    return pdpStore.lastConfirmedConfigSection;
  }

  function selectedAlgorithm() {
    // @ts-expect-error TS(4111): Property 'selectedAlgorithm' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.selectedAlgorithm;
  }

  function spangleVariations() {
    // @ts-expect-error TS(4111): Property 'spangleVariations' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.spangleVariations;
  }

  function spangleMode() {
    // @ts-expect-error TS(4111): Property 'spangleMode' comes from an index signatu... Remove this comment to see the full error message
    return spanglesStore.spangleMode;
  }

  function lastSpangledDimensions() {
    // @ts-expect-error TS(4111): Property 'lastSpangledDimensions' comes from an in... Remove this comment to see the full error message
    return spanglesStore.lastSpangledDimensions;
  }

  function spangleSizeEdited() {
    // @ts-expect-error TS(4111): Property 'spangleSizeEdited' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.spangleSizeEdited;
  }

  function spanglesLoading() {
    // @ts-expect-error TS(4111): Property 'spanglesLoading' comes from an index sig... Remove this comment to see the full error message
    return spanglesStore.spanglesLoading;
  }

  function spanglesMaxImageCount() {
    // @ts-expect-error TS(4111): Property 'spanglesMaxImageCount' comes from an ind... Remove this comment to see the full error message
    return spanglesStore.spanglesMaxImageCount;
  }

  function invalidSpangleSelected() {
    // @ts-expect-error TS(4111): Property 'invalidSpangleSelected' comes from an in... Remove this comment to see the full error message
    return spanglesStore.invalidSpangleSelected;
  }

  function allAPIsCompleted() {
    // @ts-expect-error TS(4111): Property 'allAPIsCompleted' comes from an index si... Remove this comment to see the full error message
    return spanglesStore.allAPIsCompleted;
  }

  function allAPIsFailed() {
    // @ts-expect-error TS(4111): Property 'allAPIsFailed' comes from an index signa... Remove this comment to see the full error message
    return spanglesStore.allAPIsFailed;
  }

  function isSpangleReordering() {
    // @ts-expect-error TS(4111): Property 'isSpangleReordering' comes from an index... Remove this comment to see the full error message
    return spanglesStore.isSpangleReordering;
  }

  function originalArtworkUrl() {
    // @ts-expect-error TS(4111): Property 'originalArtworkUrl' comes from an index ... Remove this comment to see the full error message
    return spanglesStore.originalArtworkUrl;
  }

  function pinningArtwork() {
    if (pinningArtworkIndex() === null) return null;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks()[pinningArtworkIndex()] ?? null;
  }

  function pinningArtworkImageUrl() {
    if (!pinningArtwork()) return "";
    const artwork = pinningArtwork();

    if (artwork.manualEditUrl) {
      return artwork.manualEditUrl;
    }

    if (artwork.enhancementTier === "print_original") {
      return artwork.originalImageUrl || artwork.url || "";
    }
    if (!isStandardArtwork()) {
      return artwork.url || artwork.originalImageUrl || "";
    }
    if (artwork.removeBackground && artwork.canRemoveBg) {
      return (
        artwork.enhancedNoBgUrl ||
        artwork.sliderPreviewUrl ||
        artwork.enhancedWithBgUrl ||
        artwork.originalImageUrl ||
        artwork.url ||
        ""
      );
    }
    return artwork.enhancedWithBgUrl || artwork.originalImageUrl || artwork.url || "";
  }

  function pinningArtworkId() {
    if (!pinningArtwork()) return "";
    return String(pinningArtwork().id || "");
  }

  function shouldShowArtworkQualityConfigPanel() {
    if (!hasArtwork()) {
      return false;
    }
    return (
      isStandardArtwork() &&
      !printAsIs() &&
      !firstArtwork().isFile &&
      !firstArtwork().isSimulated &&
      !enableAbAiMonetization()
    );
  }

  function shouldShowArtworkQualityConfigPanelAbAiMonetization() {
    if ((withError() && !isMultiSizeError()) || !hasArtwork()) {
      return false;
    }
    return (
      isStandardArtwork() &&
      !printAsIs() &&
      !firstArtwork().isFile &&
      !firstArtwork().isSimulated &&
      enableAbAiMonetization()
    );
  }

  // @ts-expect-error TS(6133): 'displayEnhancementFeedback' is declared but its v... Remove this comment to see the full error message
  function displayEnhancementFeedback() {
    return (
      enableAbAiMonetization() &&
      isStandardArtwork() &&
      !firstArtwork().isSimulated &&
      firstArtwork().id &&
      firstArtwork().enhancementCompleted &&
      firstArtwork().enhancementTier === "full_enhancements"
    );
  }

  // @ts-expect-error TS(6133): 'sampleItemPrice' is declared but its value is nev... Remove this comment to see the full error message
  function sampleItemPrice() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return Math.round(simulation().pricePerInch * 100) / 100;
  }

  function firstArtwork() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks()[0];
  }

  function isArtworkLoading() {
    return firstArtwork()?.isLoading;
  }

  function artworkUploaded() {
    const artworkId = parseInt(firstArtwork()?.id, 10);
    if (Number.isNaN(artworkId)) {
      return false;
    }
    return typeof artworkId === "number" && !isArtworkLoading();
  }

  function warningMessage() {
    return firstArtwork()?.metadata?.warnings?.human;
  }

  function defaultWidthValue() {
    if (!printAsIs()) return "";
    return "22";
  }

  function printAsIsReadOnly() {
    return printAsIs() && !!firstArtwork()?.width && !!firstArtwork()?.height;
  }

  function showSpanglesActions() {
    return isSpangle() && artworkUploaded() && !isArtworkLoading();
  }

  function showSpangleVersions() {
    return showSpanglesActions() && allAPIsCompleted();
  }

  function showMultiUploadBox() {
    return (
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      !files().length &&
      !firstArtwork().isSimulated &&
      !isSpangle() &&
      !isPuff() &&
      !isStickerSample()
    );
  }

  function showGangSheetInfoModal() {
    return !isGuest() && gangSheetPdp() && readCookie("gang-sheet-info-modal-shown") !== "true";
  }

  function gangSheetPdp() {
    return pdpType() === PDP_TYPE_GANG_SHEETS;
  }

  function supportedFileTypes() {
    // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
    return acceptedFileTypes(printAsIs());
  }

  function showArtworkCTA() {
    return showCTA() && firstArtwork()?.url;
  }

  function isMultiSizeError() {
    return firstArtwork()?.isMultiSizeError;
  }

  function hasArtwork() {
    return firstArtwork() && !firstArtwork().isSimulated && !firstArtwork().uploadError;
  }

  function withError() {
    return isArtworkWithError(firstArtwork());
  }

  function isGenericErrorVisible() {
    if (!firstArtwork() || firstArtwork().isSimulated) {
      return false;
    }
    return withError() || isFirstArtworkMinQuantityInvalid();
  }

  function headerIcon() {
    return isGenericErrorVisible() ? "strong-info" : "check-circle-bold";
  }

  function fileSize() {
    return Math.floor((firstArtwork()?.file?.size || 0) * 0.000001 || 0);
  }

  // @ts-expect-error TS(6133): 'remainingTime' is declared but its value is never... Remove this comment to see the full error message
  function remainingTime() {
    const spangleTime = isSpangle() ? 1 : 0;
    if (Math.ceil(fileSize() / 10) < 1) {
      return 1 + spangleTime;
    }
    return Math.min(Math.ceil(fileSize() / 10), sizeMessageMaxSize) + spangleTime;
  }

  function disableSizeChange() {
    if (isStandardArtwork()) {
      return outOfStock() || isArtworkLoading() || !firstArtwork().enhancementCompleted;
    }
    if (isSpangle()) {
      if (allAPIsFailed()) {
        return isArtworkLoading();
      }
      return (
        outOfStock() ||
        spangleSizeEdited() ||
        spanglesLoading() ||
        isArtworkLoading() ||
        invalidSpangleSelected() ||
        !allAPIsCompleted()
      );
    }
    return outOfStock() || isArtworkLoading();
  }

  function showArtworkFileInfo() {
    return !isSpangle();
  }

  function isDtfUsaStore() {
    return catalogNumber() === DTF001_CATALOG_NUMBER && currentStore === "usa";
  }

  function promotionWinner() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return promotionResolution()?.winner ?? "none";
  }

  function showPromotionBanner() {
    return promotionWinner() !== "none" && (isStandardArtwork() || isDieCutSticker());
  }

  // @ts-expect-error TS(6133): 'showBogoInfo' is declared but its value is never ... Remove this comment to see the full error message
  function showBogoInfo() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return isDtfUsaStore() && bogoEligibility().visible === true;
  }

  function showProColorUpsell() {
    return isDtfUsaStore() && !isGuest() && promotionWinner() === "none";
  }

  function rootStyles() {
    // @ts-expect-error TS migration
    return cn("product-details-dtf", isJerseyNumbers() && "product-details-dtf--jersey-numbers");
  }

  function showFullWidthArtwork() {
    return !sticker();
  }

  function showRedrawNote() {
    if (pdpType() === PDP_TYPE_GANG_SHEETS) return false;
    return showRedrawUI();
  }

  function showShippingProgress() {
    return firstArtwork() && !firstArtwork().isSimulated && !isArtworkLoading();
  }

  function showStoreCredit() {
    return (
      artworkUploaded() &&
      !isSticker() &&
      !isSpangle() &&
      !isGuest() &&
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      Number(storeCreditInfo().orderSubtotal) > 0
    );
  }

  function artworkEnhancementProcessing() {
    return isStandardArtwork() && !isArtworkLoading() && !firstArtwork().enhancementCompleted;
  }

  function showCancelButton() {
    const isEnhancing = artworkUploaded() && artworkEnhancementProcessing();
    return !withError() && !isSpangle() && (isArtworkLoading() || isEnhancing);
  }

  function showFreeTransfersBadge() {
    if (!isBogoApplicable()) {
      return false;
    }
    const isEnhancing = artworkUploaded() && artworkEnhancementProcessing();
    const previewReady = !isArtworkLoading() && !isEnhancing;
    if (!previewReady || !artworkUploaded()) {
      return false;
    }
    // @ts-expect-error TS(2367): This condition will always return 'true' since the... Remove this comment to see the full error message
    if (cartHasBlanks !== true && cartHasBlanks !== "true") {
      return false;
    }
    if (isGuest()) {
      return true;
    }
    if (isNewToTransfers() === null || isNewToTransfers() === undefined) {
      return false;
    }
    return isNewToTransfers() === true;
  }

  function freeTransfersBadgeMessage() {
    return `You have ${blankItemsCount()} FREE Transfers!`;
  }

  function hasPinningSessionArtworks() {
    return hasArtworksWithPinningSession(artworks());
  }

  function shouldStartBackButtonDetection() {
    if (catalogNumber() === "DTF001") {
      if (
        isDtfUserRetentionModalShown() ||
        (isPinBasedRedrawEnabled() && (showPinningModal() || hasPinningSessionArtworks()))
      ) {
        return false;
      }
      return hasUploadedAndEnhancedArtworks();
    }
    return false;
  }

  function shouldStartInactivityMonitoring() {
    if (isStandardArtwork() && catalogNumber() === "DTF001") {
      if (
        isDtfUserRetentionModalShown() ||
        (isPinBasedRedrawEnabled() && (showPinningModal() || hasPinningSessionArtworks()))
      ) {
        return false;
      }
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      const allArtworksUploaded = artworks().every(
        (artwork: any) =>
          artwork &&
          !artwork.isLoading &&
          !artwork.isSimulated &&
          !artwork.uploadError &&
          typeof parseInt(artwork.id, 10) === "number" &&
          !Number.isNaN(parseInt(artwork.id, 10))
      );
      if (!allArtworksUploaded) {
        return false;
      }
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return artworks().every((artwork: any) => artwork.enhancementCompleted === true);
    }
    return false;
  }

  function hasUploadedAndEnhancedArtworks() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks().some((artwork: any) => isUploadedAndEnhanced(artwork));
  }

  // @ts-expect-error TS(6133): 'hasArtworksInProgress' is declared but its value ... Remove this comment to see the full error message
  function hasArtworksInProgress() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return artworks().some((artwork: any) => isArtworkInProgress(artwork));
  }

  // Methods
  // @ts-expect-error TS(6133): 'closeRetentionModal' is declared but its value is... Remove this comment to see the full error message
  function closeRetentionModal() {
    setShowDtfRetentionModal(false);
  }

  function handleOpenRetentionModal(triggerVal: any) {
    if (
      !isDtfUserRetentionModalShown() &&
      (!isPinBasedRedrawEnabled() ||
        (!showPinningModal() && !hasArtworksWithPinningSession(artworks()))) &&
      hasVisibleArtworks(artworks())
    ) {
      setShowDtfRetentionModal(true);
      setTriggerPoint(triggerVal);
      setDtfUserRetentionModalShown();
    }
  }

  // Initialize monitoring hooks
  const { triggerUserInactivityMonitoring, stopMonitoring, resetTimer } = useUserInactivityDetector(
    {
      interval: INACTIVITY_INTERVAL,
      maxCallCount: INACTIVITY_MAX_CALL_COUNT,
      onInactive: () => handleOpenRetentionModal(MODAL_TRIGGER_POINTS.INACTIVITY)
    }
  );

  const { triggerUserBackButtonClickMonitoring } = useUserBackButtonClickDetector({
    onBackButtonClick: () => handleOpenRetentionModal(MODAL_TRIGGER_POINTS.BACK_BUTTON)
  });

  // Watcher: lastConfirmedConfigSection
  useEffect(() => {
    const val = lastConfirmedConfigSection();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (val?.section) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      setActiveConfigSection(val.section);
    }
  }, [JSON.stringify(lastConfirmedConfigSection())]);

  // Watcher: isGenericErrorVisible
  useEffect(() => {
    if (showStepsUI()) {
      return;
    }
    toggleGlobalDtfError(isGenericErrorVisible());
  }, [isGenericErrorVisible(), showStepsUI()]);

  // Watcher: artworkUploaded
  useEffect(() => {
    if (isStandardArtwork()) {
      setActiveConfigSection(
        firstArtwork()?.enhanceImage ? "jiffy-print-perfect" : "print-as-uploaded"
      );
      if (artworkUploaded()) {
        // @ts-expect-error TS(2345): Argument of type 'Location' is not assignable to p... Remove this comment to see the full error message
        const newUrl = new URL(window.location);
        newUrl.searchParams.delete("artwork_urls");
        newUrl.searchParams.delete("file_content_type");
        window.history.replaceState({}, "", newUrl.toString());
      }
    }
    if (isSpangle() && artworkUploaded()) {
      const url = isSpangleReordering() ? originalArtworkUrl() : firstArtwork()?.url;
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      spanglesStore.setOriginalArtworkUrl(url);
    }
    if (artworkUploaded()) {
      checkCartForBlanks();
    }
  }, [artworkUploaded()]);

  // Watcher: shouldStartInactivityMonitoring
  useEffect(() => {
    if (shouldStartInactivityMonitoring() && transferPdpInactivityDetection()) {
      triggerUserInactivityMonitoring();
    }
  }, [shouldStartInactivityMonitoring(), transferPdpInactivityDetection()]);

  // Watcher: shouldStartBackButtonDetection
  useEffect(() => {
    if (shouldStartBackButtonDetection() && transferPdpBackButtonDetection()) {
      triggerUserBackButtonClickMonitoring();
    }
  }, [shouldStartBackButtonDetection(), transferPdpBackButtonDetection()]);

  // Watcher: artworks (deep)
  useEffect(() => {
    const currentArtworks = artworks();
    const prevArtworks = prevArtworksRef.current;

    if (!prevArtworks) {
      // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'null'.
      prevArtworksRef.current = currentArtworks;
      return;
    }

    if (!shouldProcessArtworksChange()) {
      // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'null'.
      prevArtworksRef.current = currentArtworks;
      return;
    }

    const state = getArtworksState(currentArtworks, prevArtworks);

    if (handleArtworksRemoved(state)) {
      // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'null'.
      prevArtworksRef.current = currentArtworks;
      return;
    }
    if (handleArtworksStarted(state)) {
      // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'null'.
      prevArtworksRef.current = currentArtworks;
      return;
    }
    if (handleArtworksCompleted(state)) {
      // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'null'.
      prevArtworksRef.current = currentArtworks;
      return;
    }

    handleNewArtworkUploaded(currentArtworks, prevArtworks, state.hasArtworksInProgressNow);
    // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'null'.
    prevArtworksRef.current = currentArtworks;
  }, [JSON.stringify(artworks())]);

  // Watcher: spangleMode
  useEffect(() => {
    if (spangleMode() === SPANGLE_MODES.sizeEdited) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      pdpStore.updateArtworkValues({
        index: 0,
        // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
        ...lastSpangledDimensions()
      });
    }
  }, [spangleMode()]);

  // Watcher: spangleVariations
  useEffect(() => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const version = spangleVariations().find(
      ({ algorithm }: any) => algorithm === selectedAlgorithm()
    );
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    spanglesStore.selectVersion({
      version
    });
  }, [JSON.stringify(spangleVariations())]);

  // Mounted
  useEffect(() => {
    initProductSavedCartsSelector(true);
    initDeliveryDateSimple();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.initDefaultValues();
    queueMicrotask(() => {
      // @ts-expect-error TS(2339): Property 'JiffyDeliverTo' does not exist on type '... Remove this comment to see the full error message
      window.JiffyDeliverTo.reloadToggle();
    });
    document
      .querySelector(".js-dtf-product")
      ?.classList.remove("vue-product-details-dtf--mounting");
    checkFreeTransfersBadgeConditions();
    setupCartListeners();

    return () => {
      cleanupCartListeners();
    };
  }, []);

  // Before unmount
  useEffect(
    () => () => {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      pdpStore.cleanupPolling();
    },
    []
  );

  // More methods
  function showFileDialog(data: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.setReplaceArtwork(Boolean(data?.replaceArtwork));
    // @ts-expect-error TS(2339): Property 'click' does not exist on type 'never'.
    fileRef.current?.click();
  }

  function handleFileChange(event: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    spanglesStore.resetSpangles();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.resetPuff();
    const { files } = event.target; // eslint-disable-line no-shadow
    let artworkIndex = null;
    if (!files.length) return;
    if (files.length > 10) {
      // @ts-expect-error TS(4111): Property 'showFilesError' comes from an index sign... Remove this comment to see the full error message
      pdpStore.showFilesError = true;
      return;
    }
    if (files.length <= 1 && replaceArtwork()) {
      artworkIndex = 0;
    } else {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworks().forEach((artwork: any, index: any) => {
        if (isArtworkWithError(artwork)) {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          pdpStore.removeArtworkByIndex(index);
        }
      });
    }
    const uploadSource = event.target.getAttribute("data-upload-source");
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.addFilesToQueue({
      files,
      isDropEvent: false,
      artworkIndex,
      uploadSource
    });
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    fileRef.current.value = "";
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.setReplaceArtwork(false);
  }

  // @ts-expect-error TS(6133): 'changeArtworkBgColor' is declared but its value i... Remove this comment to see the full error message
  function changeArtworkBgColor(color: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.setArtworkBackground(color);
  }

  // @ts-expect-error TS(6133): 'handleDesignServiceClick' is declared but its val... Remove this comment to see the full error message
  function handleDesignServiceClick() {
    if (shouldShowArtworkQualityConfigPanelAbAiMonetization()) {
      activateDesignServiceForMonetizationV2();
    } else {
      setActiveConfigSection("jiffy-print-perfect");
    }
    focusDesignInstructionsTextarea();
  }

  function activateDesignServiceForMonetizationV2() {
    if (firstArtwork().enhancementTier !== "full_enhancements") {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      pdpStore.updateArtworkValuesById({
        id: firstArtwork().id,
        enhancementTier: "full_enhancements",
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        pricing: pdpStore.cachedArtworkPrices?.full_enhancements || {},
        hasExpertEditAddon: true
      });
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      pdpStore.updateEnableEnhancement({
        artworkId: firstArtwork().id,
        enableEnhancement: true,
        enhancementTier: "full_enhancements"
      });
    }
    if (!firstArtwork().hasExpertEditAddon) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      pdpStore.updateArtworkValuesById({
        id: firstArtwork().id,
        hasExpertEditAddon: true,
        enhancementNote: ""
      });
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      pdpStore.getArtworksPricing();
    }
  }

  function focusDesignInstructionsTextarea() {
    queueMicrotask(() => {
      const $customNotesTextarea = document.querySelector(".custom-notes__textarea");
      const $redrawTextarea =
        document.getElementById("redraw-note-0") || document.querySelector('[id^="redraw-note-"]');
      const $textarea = $customNotesTextarea || $redrawTextarea;
      if ($textarea) {
        // @ts-expect-error TS(2339): Property 'focus' does not exist on type 'Element'.
        $textarea.focus();
        $textarea.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    });
  }

  function onRemoveArtwork() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.removeArtworkWithActivity(fileToRemove());
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.getArtworksPricing();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.updatePdpDates();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    spanglesStore.resetSpangles();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.resetPuff();
  }

  function onDiscard() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.hideDiscardModal();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.dropMultiArtwork();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.updatePdpDates();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    spanglesStore.resetSpangles();
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.resetPuff();
  }

  function resetFileErrors() {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.resetFilesError();
  }

  async function checkFreeTransfersBadgeConditions() {
    try {
      if (isGuest()) {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        pdpStore.setIsNewToTransfers(true);
      } else {
        try {
          const response = await api.dtf.isNewToDtfForBogo();
          const isNew =
            typeof response === "string"
              ? response.trim().toLowerCase() === "true"
              : Boolean(response);
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          pdpStore.setIsNewToTransfers(isNew);
        } catch (error) {
          console.warn("Failed to check if user is new to transfers:", error);
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          pdpStore.setIsNewToTransfers(false);
        }
      }
      // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      setHasNoPrintTransfersHistory(isNewToTransfers());
      await checkCartForBlanks();
    } catch (error) {
      console.warn("Failed to check free transfers badge conditions:", error);
    }
  }

  async function checkCartForBlanks() {
    try {
      const response = await api.vueCart.currentItems();
      if (Object.keys(response.items || {}).length === 0) {
        updateCartCounts(0, 0);
        return;
      }
      const cartResponse = await api.vueCart.getCartState({
        cb: Date.now()
      });
      if (!cartResponse?.order_groups) {
        updateCartCounts(0, 0);
        return;
      }
      const groups = cartResponse.order_groups.groups || {};
      // @ts-expect-error TS(2339): Property 'blanks' does not exist on type 'unknown'... Remove this comment to see the full error message
      const { blanks, transfers } = countItemsInGroups(groups);
      updateCartCounts(blanks, transfers);
    } catch (error) {
      console.warn("Failed to check cart for blanks:", error);
      updateCartCounts(0, 0);
    }
  }

  function updateCartCounts(blanksCount: any, transfersCount: any) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.setBlankItemsCount(blanksCount);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    pdpStore.setTransfersInCartCount(transfersCount);
    setCartHasBlanks(blanksCount > 0);
  }

  function countItemsInGroups(groups: any) {
    return Object.values(groups).reduce(
      (totals, group) => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const lineItems = group?.line_items || group?.lineItems || {};
        const counts = countItemsInLineItems(lineItems);
        return {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          blanks: totals.blanks + counts.blanks,
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          transfers: totals.transfers + counts.transfers
        };
      },
      {
        blanks: 0,
        transfers: 0
      }
    );
  }

  function countItemsInLineItems(lineItems: any) {
    return Object.values(lineItems).reduce(
      (totals, lineItem) => {
        if (!lineItem) return totals;
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        const quantity = parseInt(lineItem.quantity, 10) || 0;
        const itemType = getLineItemType(lineItem);
        if (itemType === "blanks") {
          return {
            // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
            ...totals,
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            blanks: totals.blanks + quantity
          };
        }
        if (itemType === "transfers") {
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          const productStyle = lineItem.productStyle || lineItem.product_style;
          const catalogNum =
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            lineItem.product?.catalog_number ||
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            lineItem.catalog_number ||
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            lineItem.product?.product_style ||
            productStyle;
          const isDtf001 =
            catalogNum === DTF001_CATALOG_NUMBER || productStyle === DTF001_CATALOG_NUMBER;
          if (isDtf001) {
            return {
              // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
              ...totals,
              // @ts-expect-error TS(2571): Object is of type 'unknown'.
              transfers: totals.transfers + quantity
            };
          }
        }
        return totals;
      },
      {
        blanks: 0,
        transfers: 0
      }
    );
  }

  function getLineItemType(lineItem: any) {
    const businessLine = String(lineItem.business_line || "").toLowerCase();
    const productBusinessLine = String(lineItem.product?.business_line || "").toLowerCase();
    if (businessLine === "blanks" || productBusinessLine === "blanks") return "blanks";
    if (businessLine === "transfers" || productBusinessLine === "transfers") return "transfers";
    return null;
  }

  function setupCartListeners() {
    // @ts-expect-error TS(2322): Type '() => void' is not assignable to type 'null'... Remove this comment to see the full error message
    handleItemsAddedToCartRef.current = () => {
      checkCartForBlanks();
    };
    // @ts-expect-error TS(2322): Type '() => void' is not assignable to type 'null'... Remove this comment to see the full error message
    handleCartQuantityUpdatedRef.current = () => {
      checkCartForBlanks();
    };
    EventBus.on(Events.ITEMS_ADDED_TO_CART, handleItemsAddedToCartRef.current);
    EventBus.on(Events.CART_QUANTITY_UPDATED, handleCartQuantityUpdatedRef.current);
  }

  function cleanupCartListeners() {
    if (handleItemsAddedToCartRef.current) {
      EventBus.removeEventListener(Events.ITEMS_ADDED_TO_CART, handleItemsAddedToCartRef.current);
    }
    if (handleCartQuantityUpdatedRef.current) {
      EventBus.removeEventListener(
        Events.CART_QUANTITY_UPDATED,
        handleCartQuantityUpdatedRef.current
      );
    }
  }

  function isUploadedAndEnhanced(artwork: any) {
    return (
      artwork &&
      !artwork.isSimulated &&
      !artwork.isFile &&
      !artwork.uploadError &&
      !artwork.isLoading &&
      artwork.id &&
      typeof parseInt(artwork.id, 10) === "number" &&
      !Number.isNaN(parseInt(artwork.id, 10)) &&
      artwork.enhancementCompleted === true
    );
  }

  function isArtworkInProgress(artwork: any) {
    return (
      artwork &&
      !artwork.isSimulated &&
      !artwork.uploadError &&
      (artwork.isLoading ||
        (artwork.id &&
          typeof parseInt(artwork.id, 10) === "number" &&
          !Number.isNaN(parseInt(artwork.id, 10)) &&
          artwork.enhancementCompleted !== true))
    );
  }

  function shouldProcessArtworksChange() {
    return (
      transferPdpInactivityDetection() &&
      !isDtfUserRetentionModalShown() &&
      !showPinningModal() &&
      !hasPinningSessionArtworks() &&
      catalogNumber() === "DTF001"
    );
  }

  function getArtworksState(newArtworks: any, oldArtworks: any) {
    const hasArtworksInProgressNow = newArtworks.some((artwork: any) =>
      isArtworkInProgress(artwork)
    );
    const hadArtworksInProgressBefore = oldArtworks.some((artwork: any) =>
      isArtworkInProgress(artwork)
    );
    const hasUploadedAndEnhancedNow = newArtworks.some((artwork: any) =>
      isUploadedAndEnhanced(artwork)
    );
    const hadUploadedAndEnhancedBefore = oldArtworks.some((artwork: any) =>
      isUploadedAndEnhanced(artwork)
    );
    return {
      hasArtworksInProgressNow,
      hadArtworksInProgressBefore,
      hasUploadedAndEnhancedNow,
      hadUploadedAndEnhancedBefore
    };
  }

  function handleArtworksRemoved(state: any) {
    if (state.hadUploadedAndEnhancedBefore && !state.hasUploadedAndEnhancedNow) {
      stopMonitoring();
      return true;
    }
    return false;
  }

  function handleArtworksStarted(state: any) {
    if (!state.hadArtworksInProgressBefore && state.hasArtworksInProgressNow) {
      stopMonitoring();
      return true;
    }
    return false;
  }

  function handleArtworksCompleted(state: any) {
    if (
      state.hadArtworksInProgressBefore &&
      !state.hasArtworksInProgressNow &&
      state.hasUploadedAndEnhancedNow
    ) {
      resetTimer();
      return true;
    }
    return false;
  }

  function handleNewArtworkUploaded(
    newArtworks: any,
    oldArtworks: any,
    hasArtworksInProgressNow: any
  ) {
    const newCount = newArtworks.filter((artwork: any) => isUploadedAndEnhanced(artwork)).length;
    const oldCount = oldArtworks.filter((artwork: any) => isUploadedAndEnhanced(artwork)).length;
    if (newCount > oldCount && !hasArtworksInProgressNow) {
      resetTimer();
    }
  }

  // Render
  return (
    <>
      <div className={cn("scope-d0072188", rootStyles(), restClassName)} {...restProps}>
        {isJerseyNumbers() ? (
          <JerseyNumbers
            // @ts-expect-error TS(2322): Type '{ className: string; "data-testid": string; ... Remove this comment to see the full error message
            className="product-details-dtf__jersey-numbers scope-d0072188"
            data-testid="product-details-dtf-jersey-numbers"
          />
        ) : null}
        {isLetters() ? (
          <Letters
            className="product-details-dtf__letters scope-d0072188"
            data-testid="product-details-dtf-letters"
          />
        ) : null}
        {firstArtwork() && !firstArtwork().isSimulated && !showStepsUI() ? (
          <div
            className={cn("product-details-dtf__file-name scope-d0072188", {
              "product-details-dtf__file-name--with-error": isGenericErrorVisible(),
              "product-details-dtf__file-name--full-width": showFullWidthArtwork()
            })}
          >
            {!!firstArtwork().metadata || isGenericErrorVisible() ? (
              <UseSvg
                className={cn("product-details-dtf__header-icon scope-d0072188", {
                  "product-details-dtf__header-icon--with-error": isGenericErrorVisible()
                })}
                icon={headerIcon()}
                data-testid="product-details-dtf-header-icon"
              />
            ) : null}
            <span className="product-details-dtf__header-text scope-d0072188">
              {firstArtwork().name}
            </span>
          </div>
        ) : null}
        {!outOfStock() &&
        !isMobile() &&
        (slots.dates || (gangSheetPdp() && slots["free-shipping"])) ? (
          <div className="product-details-dtf__dates-container hidden-xs scope-d0072188">
            {gangSheetPdp() ? slots["free-shipping"]?.() : null}
            <DeliveryDate className="scope-d0072188" data-testid="delivery-date" />
          </div>
        ) : null}
        {isGangSheetBuilder() ? (
          <>
            <GangSheetBuilderPdpContainer
              className="scope-d0072188"
              currentStore={currentStore}
              data-testid="gang-sheet-builder-pdp-container"
            />

            {slots["saved-carts"]?.()}
          </>
        ) : null}
        {!isJerseyNumbers() && !isLetters() && !isGangSheetBuilder() ? (
          <>
            {showPromotionBanner() ? (
              <>
                {promotionWinner() !== "bogo" ? (
                  <div
                    className={cn(
                      "product-details-dtf__promotion-banner scope-d0072188",
                      `product-details-dtf__promotion-banner--winner-${promotionWinner()}`
                    )}
                  >
                    {slots["promotion-banner"]?.()}
                  </div>
                ) : promotionWinner() === "bogo" ? (
                  <BogoInfo
                    className="scope-d0072188"
                    // @ts-expect-error TS(2571): Object is of type 'unknown'.
                    reason={bogoEligibility().reason}
                    // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
                    isGuest={isGuest()}
                    // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'string |... Remove this comment to see the full error message
                    maxFreeDimensionLabel={bogoMaxDimensionLabel()}
                    data-testid="bogo-info"
                  />
                ) : null}
              </>
            ) : null}
            {showProColorUpsell() && isStandardArtwork() ? (
              <ProColorUpsell
                className="product-details-dtf__pro-color-upsell scope-d0072188"
                artwork={firstArtwork()}
                data-testid="product-details-dtf-pro-color-upsell"
              />
            ) : null}
            {!outOfStock() && neckLabel() ? (
              <DesignTagCreationPanel
                className="scope-d0072188"
                data-testid="design-tag-creation-panel"
              />
            ) : null}
            {!outOfStock() && !neckLabel() ? (
              <StepWrapper
                className="product-details-dtf__step-1 scope-d0072188"
                hasError={showStepsUI() && isGenericErrorVisible()}
                borderless={!showStepsUI()}
                stepNumber={1}
                headerText="Upload Your Design(s)"
                slots={{
                  "header-badge": () => (
                    <>
                      {showFreeTransfersBadge() ? (
                        <FreeTransfersBadge
                          className="product-details-dtf__free-transfers-badge scope-d0072188"
                          message={freeTransfersBadgeMessage()}
                          data-testid="product-details-dtf-free-transfers-badge"
                        />
                      ) : null}
                    </>
                  ),

                  "step-number-content": () =>
                    showCancelButton() ? (
                      <button
                        className="product-details-dtf__cancel scope-d0072188"
                        type="button"
                        onClick={() => {
                          // @ts-expect-error TS(2571): Object is of type 'unknown'.
                          pdpStore.handleCancelProcess(firstArtwork());
                        }}
                        data-testid="product-details-dtf-cancel"
                      >
                        <UseSvg
                          className="product-details-dtf__cancel-icon scope-d0072188"
                          icon="modal-close"
                          data-testid="product-details-dtf-cancel-icon"
                        />{" "}
                        Cancel{" "}
                      </button>
                    ) : null
                }}
                data-testid="product-details-dtf-step-1"
              >
                <ArtworkInfo
                  className="scope-d0072188"
                  artwork={firstArtwork()}
                  showFileInfo={showArtworkFileInfo()}
                  index={0}
                  data-testid="artwork-info"
                />

                <ArtworkImage
                  className="scope-d0072188"
                  artwork={firstArtwork()}
                  activeConfigSection={activeConfigSection}
                  showFullScreenButton={true}
                  onClick={showFileDialog}
                  data-testid="artwork-image"
                />

                {!isStandardArtwork() && !firstArtwork().isFile && !firstArtwork().isSimulated ? (
                  <TrimInfo
                    className="scope-d0072188"
                    id={firstArtwork().id}
                    artwork={firstArtwork()}
                    background={firstArtwork().background}
                    canRemoveBg={firstArtwork().canRemoveBg}
                    removeBackground={firstArtwork().removeBackground}
                    toggleBackgroundError={firstArtwork().toggleBackgroundError}
                    data-testid="trim-info"
                  />
                ) : null}
                {shouldShowArtworkQualityConfigPanel() ? (
                  <ArtworkQualityConfigPanel
                    className="scope-d0072188"
                    key={firstArtwork().id}
                    artwork={firstArtwork()}
                    activeConfigSection={activeConfigSection}
                    onSetActiveConfigSection={setActiveConfigSection}
                    data-testid="artwork-quality-config-panel"
                  />
                ) : null}
                {shouldShowArtworkQualityConfigPanelAbAiMonetization() ? (
                  <ArtworkQualityConfigPanelAbAiMonetization
                    className="scope-d0072188"
                    index={0}
                    artwork={firstArtwork()}
                    reorderEnabled={reorderEnabled()}
                    activeConfigSection={activeConfigSection}
                    paidExpertEditAddonEnabled={paidExpertEditAddonEnabled()}
                    onSetActiveConfigSection={setActiveConfigSection}
                    data-testid="artwork-quality-config-panel-ab-ai-monetization"
                  />
                ) : null}
                {isPuff() && !showStepsUI() ? (
                  <PuffColorSelector
                    className="scope-d0072188"
                    label="Select Puff Color"
                    data-testid="puff-color-selector"
                  />
                ) : null}
                {/* @ts-expect-error TS(2571): Object is of type 'unknown'. */}
                {sticker() && artworkUploaded() && experiments().stickers_style_options ? (
                  <StickersTools
                    className="product-details-dtf__section scope-d0072188"
                    artwork={firstArtwork()}
                    data-testid="product-details-dtf-section"
                  />
                ) : null}
                {!isStandardArtwork() ? (
                  <>
                    {showRedrawNote() ? (
                      <RedrawNotes
                        className="scope-d0072188"
                        enhancementNote={firstArtwork().enhancementNote}
                        data-testid="redraw-notes"
                      />
                    ) : null}
                    {showProColorUpsell() ? (
                      <ProColorUpsell
                        className="product-details-dtf__section scope-d0072188"
                        artwork={firstArtwork()}
                        data-testid="product-details-dtf-section-1"
                      />
                    ) : null}
                  </>
                ) : null}
                {showArtworkCTA() ? (
                  <ArtworkCTA
                    className="scope-d0072188"
                    artworkUrl={firstArtwork().url}
                    data-testid="artwork-cta"
                  />
                ) : null}
                {withError() && !isMultiSizeError() ? (
                  <ArtworkError
                    className="scope-d0072188"
                    artwork={firstArtwork()}
                    currentStore={currentStore}
                    data-testid="artwork-error"
                  />
                ) : null}
                {!withError() && warningMessage() ? (
                  <ArtworkNotification
                    className="scope-d0072188"
                    data-testid="artwork-notification"
                  >
                    <b className="scope-d0072188">{warningMessage()}</b>
                  </ArtworkNotification>
                ) : null}
              </StepWrapper>
            ) : null}
            {isPuff() && showStepsUI() ? (
              <PuffColorSelector
                className="scope-d0072188"
                label="Select Puff Color"
                data-testid="puff-color-selector-1"
              />
            ) : null}
            {!showModal() && !neckLabel() ? (
              <>
                {showMultiSize() ? (
                  <MultiSizeStep
                    className="scope-d0072188"
                    artwork={firstArtwork()}
                    disabled={disableSizeChange()}
                    readonly={printAsIsReadOnly()}
                    withPreCut={withPreCut()}
                    showMultiUploadBox={showMultiUploadBox()}
                    isArtworkUploaded={artworkUploaded()}
                    showFreeTransfersBadge={showFreeTransfersBadge()}
                    onShowFileDialog={showFileDialog}
                    data-testid="multi-size-step"
                  />
                ) : !isStickerSample() && !showMultiSize() ? (
                  <ArtworkDimensions
                    className={cn("scope-d0072188", {
                      "product-details-dtf__dimensions--near-quantity":
                        // @ts-expect-error TS(2571): Object is of type 'unknown'.
                        !showStepsUI() && printAsIs() && modalArtworks().length <= 1
                    })}
                    artwork={firstArtwork()}
                    disabled={disableSizeChange()}
                    // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'null | un... Remove this comment to see the full error message
                    widthDefault={defaultWidthValue()}
                    // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
                    readonly={printAsIsReadOnly()}
                    currentStore={currentStore}
                    data-testid="artwork-dimensions"
                  />
                ) : null}
              </>
            ) : null}
            {showSpanglesActions() ? (
              <DtfSpanglesActions
                className="scope-d0072188"
                isArtworkInvalid={withError()}
                data-testid="dtf-spangles-actions"
              />
            ) : null}
            {showSpangleVersions() && !isSpangleReordering() ? (
              <DtfSpangleVersions className="scope-d0072188" data-testid="dtf-spangle-versions" />
            ) : null}
            {showSpangleVersions() || isSpangleReordering() ? (
              <DtfSpanglesColorSelector
                className="scope-d0072188"
                data-testid="dtf-spangles-color-selector"
              />
            ) : null}
          </>
        ) : null}
        {isStickerSample() ? (
          <input
            className="artwork-quantity__input js-quantity-form-input scope-d0072188"
            type="hidden"
            data-variant-id={variantId()}
            value={10}
            data-testid="artwork-quantity-input"
          />
        ) : !showMultiSize() && !isGangSheetBuilder() && !neckLabel() ? (
          <ArtworkQuantity
            className="scope-d0072188"
            artwork={firstArtwork()}
            showFreeShipping={true}
            // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'boolean ... Remove this comment to see the full error message
            disabled={outOfStock()}
            data-testid="artwork-quantity"
          />
        ) : null}
        {!neckLabel() ? (
          <>
            {withPreCut() && !showMultiSize() && !neckLabel() ? (
              <PreCut className="scope-d0072188" data-testid="pre-cut" />
            ) : null}
            {outOfStock() ? (
              <NotifyOnRestock className="scope-d0072188" data-testid="notify-on-restock" />
            ) : null}
            {!outOfStock() && !neckLabel() ? (
              <DropZone className="scope-d0072188" data-testid="drop-zone" />
            ) : null}
          </>
        ) : null}
        <input
          className="product-details-dtf__file scope-d0072188 hidden"
          id="product-details-dtf-file-input"
          ref={fileRef}
          type="file"
          data-testid="product-details-dtf-file-input"
          accept={supportedFileTypes()}
          multiple={
            // @ts-expect-error TS(2571): Object is of type 'unknown'.
            (!isSpangle() || spanglesMaxImageCount() > 1) && !isPuff() && !isStickerSample()
          }
          onChange={handleFileChange}
        />

        {showModal() ? (
          <MultiArtworkModal
            className="scope-d0072188"
            key={firstArtwork().id}
            moveBellow={
              !!fileToRemove() ||
              showDiscardModal() ||
              showFilesError() ||
              showDtfRetentionModal ||
              showPinningModal()
            }
            currentStore={currentStore}
            activeConfigSection={activeConfigSection}
            onUpload={showFileDialog}
            slots={{
              "saved-carts": () => <>{slots["saved-carts-modal"]?.()}</>,
              "free-shipping": () => <>{slots["free-shipping"]?.()}</>
            }}
            data-testid="multi-artwork-modal"
          />
        ) : null}
        {showPinningModal() && pinningArtwork() && pinningModalSessionId() ? (
          <PinningSessionModal
            className="scope-d0072188"
            artworkIndex={pinningArtworkIndex()}
            artworkImageUrl={pinningArtworkImageUrl()}
            artworkId={pinningArtworkId()}
            sessionId={pinningModalSessionId()}
            data-testid="pinning-session-modal"
          />
        ) : null}
        {pendingPinningInvalidation() ? (
          <DtfConfirmationModal
            className="scope-d0072188"
            // @ts-expect-error TS(4111): Property 'confirmPinningInvalidation' comes from a... Remove this comment to see the full error message
            onSubmit={pdpStore.confirmPinningInvalidation}
            // @ts-expect-error TS(4111): Property 'cancelPinningInvalidation' comes from an... Remove this comment to see the full error message
            onClose={pdpStore.cancelPinningInvalidation}
            slots={{
              header: () => <>Remove Design Request?</>,
              text: () => (
                <>
                  {" "}
                  This change will remove your design request, are you sure you want to
                  proceed?{" "}
                </>
              ),

              button: () => <>Yes, Remove</>,
              cancel: () => <>Keep Request</>
            }}
            data-testid="dtf-confirmation-modal"
          />
        ) : null}
        {showArtworkHistoryModal() ? (
          <ArtworkHistoryModal
            className="scope-d0072188"
            reorderEnabled={reorderEnabled()}
            data-testid="artwork-history-modal"
          />
        ) : null}
        {!outOfStock() ? (
          <div className="product-details-dtf__dates-container visible-xs scope-d0072188">
            {gangSheetPdp() ? slots["free-shipping"]?.() : null}
            <DeliveryDate className="scope-d0072188" data-testid="delivery-date-1" />
          </div>
        ) : null}
        {isStickerSample() ? (
          <StickerSampleBanner className="scope-d0072188" data-testid="sticker-sample-banner" />
        ) : null}
        {showMultiUploadBox() && !showMultiSize() ? (
          <div className="product-details-dtf__upload scope-d0072188">
            <UploadBox
              className="scope-d0072188"
              onUpload={showFileDialog}
              data-testid="upload-box"
            />
          </div>
        ) : null}
        {!isGangSheetBuilder() ? (
          <>
            {showMultiSize() ? (
              <StepWrapper
                className="scope-d0072188"
                stepNumber={3}
                headerText="Review and Add to Cart"
                data-testid="step-wrapper"
              >
                <MultiSizeTotal className="scope-d0072188" data-testid="multi-size-total" />
                <div className="js-product-details-delivery-date-pdp-container scope-d0072188 hidden">
                  <DeliveryDate
                    className="scope-d0072188"
                    hideAddressLine={true}
                    compact={true}
                    isSameDay={true}
                    data-testid="delivery-date-2"
                  />

                  <span className="product-details-dtf__or scope-d0072188">Or</span>
                </div>
                {showShippingProgress() ? slots["free-shipping"]?.() : null}
                {showStoreCredit() ? (
                  <div className="product-details-dtf__store-credit scope-d0072188">
                    <TransfersStoreCredit
                      className="scope-d0072188"
                      storeCreditInfo={storeCreditInfo()}
                      data-testid="transfers-store-credit"
                    />
                  </div>
                ) : null}
                {slots["saved-carts"]?.()}
                {!showModal() ? (
                  <DtfAddToCart className="scope-d0072188" data-testid="dtf-add-to-cart" />
                ) : null}
                {slots.favorite?.()}
              </StepWrapper>
            ) : (
              <div className="scope-d0072188">
                {showStoreCredit() ? (
                  <TransfersStoreCredit
                    className="scope-d0072188"
                    storeCreditInfo={storeCreditInfo()}
                    data-testid="transfers-store-credit-1"
                  />
                ) : null}
                {slots["saved-carts"]?.()}
                {!showModal() && !neckLabel() ? (
                  <DtfAddToCart className="scope-d0072188" data-testid="dtf-add-to-cart-1" />
                ) : null}
              </div>
            )}
          </>
        ) : null}
        {fileToRemove() ? (
          <DtfConfirmationModal
            className="scope-d0072188"
            // @ts-expect-error TS(4111): Property 'resetRemovalFile' comes from an index si... Remove this comment to see the full error message
            onClose={pdpStore.resetRemovalFile}
            onSubmit={onRemoveArtwork}
            slots={{
              header: () => <>Remove File</>,
              text: () => <>This file will be removed. Do you confirm?</>,
              button: () => <>Remove File</>
            }}
            data-testid="dtf-confirmation-modal-1"
          />
        ) : null}
        {showDiscardModal() ? (
          <DtfConfirmationModal
            className="scope-d0072188"
            // @ts-expect-error TS(4111): Property 'hideDiscardModal' comes from an index si... Remove this comment to see the full error message
            onClose={pdpStore.hideDiscardModal}
            onSubmit={onDiscard}
            slots={{
              header: () => <>Discard Changes</>,
              text: () => (
                <>
                  {" "}
                  All the changes and artworks will be discarded.
                  <br className="scope-d0072188" />
                  Are you sure you want to proceed?{" "}
                </>
              ),

              button: () => <>Discard Changes</>
            }}
            data-testid="dtf-confirmation-modal-2"
          />
        ) : null}
        {showFilesError() ? (
          <DtfConfirmationModal
            className="scope-d0072188"
            onClose={resetFileErrors}
            slots={{
              header: () => <>Warning</>,
              text: () => <> You can only upload up to 10 files simultaneously. </>,
              cancel: () => <>OK</>
            }}
            data-testid="dtf-confirmation-modal-3"
          />
        ) : null}
        {showGangSheetInfoModal() ? (
          <GangSheetInfoModal
            className="scope-d0072188"
            currentStore={currentStore}
            data-testid="gang-sheet-info-modal"
          />
        ) : null}
      </div>
      <DtfTransferUserRetentionModal
        className="scope-d0072188"
        isOpen={showDtfRetentionModal}
        onUpdateIsOpen={(val: any) => {
          setShowDtfRetentionModal(val);
        }}
        isMultiArtworkModalOpen={showModal()}
        isPinBasedRedrawEnabled={isPinBasedRedrawEnabled()}
        triggerPoint={triggerPoint}
        data-testid="dtf-transfer-user-retention-modal"
      />
    </>
  );
}

export default ProductDetailsDtf;
